<div #component></div>
<p-drawer
  [(visible)]="sidebarVisible"
  [closeOnEscape]="false"
  [dismissible]="false"
  position="right"
  [appendTo]="component"
>
  <ng-template pTemplate="headless">
    <div
      [ngClass]="{
        'justify-content-center': data?.hideCloseButton,
        'justify-content-between': !data?.hideCloseButton
      }"
      class="px-3 pt-3 pb-3 pl-4 header flex"
    >
      <a (click)="onHide()" *ngIf="data?.hideCloseButton !== true" class="cursor-pointer flex align-items-center">
        <img alt="close-icon.svg" src="assets/images/close-icon.svg" />
      </a>
      <h5 class="m-0">{{ data?.title | translate }}</h5>
      <span style="width: 20px">&nbsp;</span>
    </div>

    <div [ngClass]="{ 'full-height': data?.hideCancelButton && data?.hideOkButton }" class="content">
      <div class="content-scroll">
        <div>
          <ng-content></ng-content>
        </div>
        <form *ngIf="data?.isReasonSidebar" [formGroup]="reasonForm" class="reason-form">
          <div class="reason-section">
            <label class="font-bold" for="reason">ระบุเหตุผล <span class="text-danger">*</span></label>
            <textarea
              [autoResize]="false"
              [ngClass]="{
                'is-invalid': reasonForm.get('reason')?.invalid && reasonForm.get('reason')?.touched
              }"
              formControlName="reason"
              id="reason"
              maxlength="250"
              pTextarea
              placeholder="ระบุเหตุผล"
              rows="4"
            ></textarea>
            <div
              *ngIf="reasonForm.get('reason')?.invalid && reasonForm.get('reason')?.touched"
              class="invalid-feedback"
            >
              {{ 'ERRORS.REQUIRED' | translate }}
            </div>
          </div>
        </form>
      </div>
    </div>

    <div *ngIf="data?.hideCancelButton !== true || data?.hideOkButton !== true" class="footer">
      <button
        (click)="onClickCancel()"
        *ngIf="data?.hideCancelButton !== true"
        [label]="data?.cancelText || 'SIDEBAR.BUTTON.CANCEL' | translate"
        class="w-full p-button-outlined p-button-cancel"
        data-id="backForceCloseShift"
        pButton
        pRipple
        type="button"
      ></button>

      <p-button
        (click)="onClickOk()"
        *ngIf="data?.hideOkButton !== true"
        [label]="data?.okText || 'SIDEBAR.BUTTON.CONFIRM' | translate"
        data-id="submitForceCloseShift"
        id="btn-submit-tax-invoice"
        severity="secondary"
        styleClass="login-btn w-full"
        type="submit"
      ></p-button>
    </div>
  </ng-template>
</p-drawer>
